<template>
  <div>
    <headerTop ref="store"></headerTop>
    <headerSearch :flag="1"></headerSearch>
    <div class="wrapper">
      <!-- 我的关注 -->
      <div class="attention_top">
        <div style="font-size: 20px; font-weight: bold">{{ $t('focus.my') }}</div>
        <div class="qbFocus">
          <div class="entire">
            <span
              @click="allattentiondj"
              style="margin-right: 8px; cursor: pointer; font-size: 16px"
              >{{ $t('focus.Full') }}</span
            >
            <span>{{ allattention }}</span>
          </div>
          <ul>
            <li
              v-for="(item, index) in attentionlist"
              :key="index"
              @click="checkedEvent(item.id, index)"
              :class="index == checkedType ? 'checked' : ''"
            >
              <span style="margin-right: 5px">{{ item.label }}</span>
              <span>(</span>
              <span style="color: red">{{ item.level }}</span>
              <span>)</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 下面关注的表 -->
      <div
        style="padding: 0; margin: 0; height: 50px"
        v-show="sheetlist.length > 0"
      >
        <Page
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          :page-size-opts="[30]"
          size="small"
          show-total
          show-sizer
          @on-change="changeCurrentgz"
          @on-page-size-change="changeSizegz"
        />
      </div>
      <div class="attention_content">
        <Row class="tableHeader">
          <Col span="2">{{ $t('focus.picture') }}</Col>
          <Col style="width: 250px">{{ $t('focus.info') }}</Col>
          <Col span="3">{{ $t('focus.store') }}</Col>
          <Col span="3">{{ $t('focus.place') }}</Col>
          <Col span="2">{{ $t('focus.stock') }}</Col>
          <Col span="3">{{ $t('focus.price') }}</Col>
          <Col span="3">{{ $t('focus.Purchase') }}</Col>
          <Col style="width: 120px; margin-left: 8px">{{ $t('focus.operate') }}</Col>
        </Row>
        <div class="sheet">
          <transition-group
            name="more"
            v-bind:css="false"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
          >
            <div
              v-for="(item, index) in sheetlist"
              :key="item.id"
              class="tableCenter"
            >
              <Row>
                <Col span="2">
                  <img
                    class="img1"
                    v-if="item.pictureUrl"
                    :src="item.pictureUrl"
                    alt=""
                  />
                  <img
                    v-else
                    class="img1"
                    src="https://img.g-part.cn/prod/wss/default_null.png"
                    alt=""
                  />
                </Col>
                <Col style="width: 250px">
                  <div class="show">
                    <div class="zflex ml5 w120">
                      <span v-show="item.typeName" class="sapn1">{{
                        item.typeName
                      }}</span>
                      <div
                        @click="skipxq(item)"
                        style="cursor: pointer"
                        class="w121"
                      >
                        <span style="cursor: pointer">{{
                          item.carBrandName
                        }}</span>
                        <span style="cursor: pointer">{{
                          item.stdNameJp
                        }}</span>
                        <span style="cursor: pointer">{{ item.oeCode }}</span>
                      </div>
                    </div>
                    <div class="mt15">
                      <ul class="zflex ml5">
                        <li>服务：</li>
                        <li v-show="item.genuineGuarantee">
                          <span class="iconfont icon-a-lujing153"></span>
                          <!-- <span>正品保证</span> -->
                        </li>
                        <li v-show="item.technicalSupport">
                          <span class="iconfont icon-a-ziyuan4"></span>
                          <!-- <span>技术支持</span> -->
                        </li>
                        <li v-show="item.warrantyService">
                          <span class="iconfont icon-a-ziyuan5"></span>
                          <!-- <span>保修服务</span> -->
                        </li>
                        <li v-show="item.returnPromise">
                          <span class="iconfont icon-a-ziyuan21"></span>
                          <!-- <span>退换货承诺</span> -->
                        </li>
                      </ul>
                    </div>
                    <div class="oe-p" @mouseleave="closeRelevance(index)">
                      OE号：
                      <p
                        @mouseenter="getRelevance(index, item)"
                        v-if="item.oemCodes && item.oemCodes.length > 0"
                      >
                        {{ item.oemCodes[0]
                        }}<i
                          class="ivu-icon ivu-icon-ios-arrow-down"
                          v-if="item.oemCodes.length > 1"
                        ></i>
                      </p>
                      <div
                        class="relevance"
                        :tabIndex="1"
                        v-if="item.oemCodes.length > 1"
                      >
                        <div
                          class="relevanceBox"
                          :class="item.isShow ? 'show' : ''"
                        >
                          <p v-for="i in item.oemCodes.slice(1)" :key="i">
                            {{ i }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col span="3">
                  <div class="shop">
                    <!-- 这期隐藏 -->
                    <div style="cursor: pointer" @click="skipdp(item)">
                      <!-- <div style="cursor: pointer"> -->
                      {{ item.shopName }}
                    </div>
                    <div style="margin-top: 7px">
                      {{ item.provinceName }}{{ item.cityName }}
                    </div>
                  </div>
                </Col>
                <!-- 发货地 -->
                <Col span="3">
                  <div class="oe-p" @mouseleave="closeCity(index)">
                    <p
                      class="w122"
                      @mouseenter="getCity(index, item)"
                      v-if="item.shipCityStores.length"
                    >
                      {{ item.shipCityStore.city }}
                      {{ item.shipCityStore.name }}
                      <i
                        class="ivu-icon ivu-icon-ios-arrow-down"
                        v-if="item.shipCityStores.length > 1"
                      ></i>
                    </p>
                    <div
                      class="relevance"
                      :tabIndex="1"
                      v-if="item.shipCityStores.length > 1"
                    >
                      <div
                        class="relevanceBox w33"
                        :class="item.isShows ? 'show' : ''"
                      >
                        <p
                          v-for="i in item.shipCityStores"
                          :key="i.index"
                          class="w22"
                          :class="isCity === i.name ? 'isCityed' : ''"
                          @click="checkCITY(i, item)"
                        >
                          {{ i.city }}
                          {{ i.name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
                <!-- 库存 -->
                <Col span="2">
                  <div v-show="item.saleStatus == 1">
                    {{ item.stock > 10 ? '10+' : item.stock }}/{{ item.unitId }}
                  </div>
                </Col>
                <!-- 价格 -->
                <Col span="3">
                  <div
                    class="price"
                    v-show="item.inquiry == 0 && item.saleStatus == 1"
                  >
                    <div class="flex fz18 hs bold">
                      <span v-show="item.type"
                        ><i class="iconfont icon-a-lujing156"></i></span
                      >&yen;{{ item.price }}
                    </div>
                    <div v-show="item.priceReduction" class="depreciate">
                      降价&yen;{{ item.priceReduction }}
                    </div>
                    <div v-show="item.type">
                      <i class="iconfont icon-a-lujing156"></i>
                      {{ item.activityTime }}
                    </div>
                  </div>
                  <div v-show="item.inquiry && item.saleStatus == 1">
                    <span class="fz18 hs">询价</span>
                  </div>
                  <div v-show="item.saleStatus == 2">
                    <span class="fz16">商品已下架</span>
                  </div>
                </Col>
                <!-- 购买数量 -->
                <Col span="3">
                  <div class="number">
                    <div class="number-in">
                      <Button
                        class="number-sub"
                        @click="cliSub(item, index)"
                        :disabled="item.Sub"
                        >-</Button
                      >
                      <input
                        oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                        :id="index"
                        @blur="BlurNumber(item, index)"
                        v-model="item.maxNum"
                        style="
                          width: 50px;
                          text-align: center;
                          line-height: 31px;
                        "
                      />
                      <Button
                        class="number-add"
                        @click="cliAdd(item, index)"
                        :disabled="item.Add"
                        >+</Button
                      >
                    </div>
                    <div class="number-sp" :class="item.isNumber ? 'show' : ''">
                      库存不足
                    </div>
                  </div>
                </Col>
                <!-- 操作 -->
                <Col style="width: 120px; margin-left: 12px">
                  <div class="operate">
                    <div style="text-algin: center" class="icon">
                      <span
                        class="iconfont"
                        :class="
                          item.attention ? 'icon-a-ziyuan1' : 'icon-a-lujing157'
                        "
                        @click="collect(item)"
                      ></span>
                      <span
                        v-show="item.inquiry == 0 && item.saleStatus == 1"
                        class="gzcart"
                        @click="joinshopcar(item, index)"
                        ><i class="iconfont icon-a-zu420"></i
                      ></span>
                      <span
                        v-show="item.inquiry == 1 || item.saleStatus == 2"
                        class="xjcart"
                      >
                        <i class="iconfont icon-a-zu420"></i>
                      </span>
                      <xiaopei
                        v-if="item.saleStatus !== 2"
                        :oppositeTenantId="item.tenantId"
                        :partId="item.id"
                      >
                        <i class="iconfont icon-a-lujing162"></i>
                      </xiaopei>
                      <i
                        class="iconfont icon-a-lujing162"
                        v-else
                        style="color: #aaaaaa"
                      ></i>
                      <span
                        class="blue"
                        v-show="item.saleStatus == 2 || item.inquiry == 1"
                        @click="same(item)"
                      >
                        找同款
                      </span>
                    </div>
                    <!--  v-if="item.inquiry == 0 && item.saleStatus == 1" -->
                    <div
                      style="width: 100%; padding-top: 8px"
                      v-if="item.inquiry == 0 && item.saleStatus == 1"
                    >
                      <Button
                        style="
                          margin: 0 auto;
                          background-color: #ff5e00;
                          color: #fff;
                          display: block;
                        "
                        @click="promptlybuy(item)"
                        >{{ $t('home.immediately') }}</Button
                      >
                    </div>
                    <!-- v-if="item.inquiry == 1" -->
                    <!-- <div> -->
                    <div
                      style="width: 100%; padding-top: 8px"
                      v-if="item.inquiry == 1 && item.saleStatus == 1"
                    >
                      <Button
                        style="
                          background-color: #377cf1;
                          color: #fff;
                          margin: 0 auto;
                          display: block;
                        "
                        @click="promptlyxj(item)"
                        >{{ $t('home.Inquire') }}</Button
                      >
                    </div>
                    <div
                      style="width: 100%; padding-top: 8px"
                      v-show="item.saleStatus == 2"
                    >
                      <Button
                        style="
                          background-color: #8b8c94;
                          color: #fff;
                          margin: 0 auto;
                          display: block;
                        "
                        >{{ $t('home.immediately') }}</Button
                      >
                    </div>
                  </div>
                </Col>
                <!-- <Col span="12">col-12</Col> -->
              </Row>
            </div>
          </transition-group>
          <!-- 关注为空 -->
          <div class="emptyData" v-show="sheetlist.length == 0">
            <div class="min">
              <span
                style="font-size: 14px; padding: 0 9px 0 5px"
                class="iconfont icon-gantanhao-xianxingyuankuang"
              ></span>
              <span style="font-size: 14px">抱歉！没找到你想要的数据~!</span>
            </div>
          </div>
          <!-- 加载中 -->
          <div class="demo-spin-container" v-if="spinShow">
            <Spin fix></Spin>
          </div>
        </div>
      </div>
      <div class="pagefy" v-show="sheetlist.length > 0">
        <Page
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          :page-size-opts="[30]"
          size="small"
          show-total
          show-sizer
          @on-change="changeCurrentgz"
          @on-page-size-change="changeSizegz"
        />
      </div>
    </div>
    <Footer></Footer>
    <footerP></footerP>
    <!-- 立即询价弹框 -->
    <!-- <Modal
      v-model="enquirytk"
      title="请确认询价信息:"
      :closable="false"
      footer-hide
      :mask-closable="false"
      class-name="vertical-center-modal"
      width="600px"
    >
      <div slot="header" class="h30">
        <div class="fz18xj">请确认询价信息&nbsp;:</div>
      </div>
      <p class="redxj mb10">询价有效期为8小时</p>
      <div>
        <span style="margin-right:130px">卖家&nbsp;:</span>
        <span>{{ enquirydata.shopName }}</span>
      </div>
      <div class="flexj mt20">
        <span style="margin-right:100px">
          询价商品&nbsp;:
        </span>
        <div>
          <div class="mb5">
            <span style="margin-right:20px" class="partypexj">{{
              enquirydata.typeName
            }}</span>
            <span
              >{{ enquirydata.carBrandName }}{{ enquirydata.stdNameJp
              }}{{ enquirydata.oeCode }}</span
            >
          </div>
          <div class="xishop">
            <li v-if="enquirydata.genuineGuarantee">
              <span class="iconfont icon-a-lujing153"></span>
              <p>正品保证</p>
            </li>
            <li v-if="enquirydata.technicalSupport">
              <span class="iconfont icon-a-ziyuan4"></span>
              <p>技术支持</p>
            </li>
            <li v-if="enquirydata.warrantyService">
              <span class="iconfont icon-a-ziyuan5"></span>
              <p>保修服务</p>
            </li>
            <li v-if="enquirydata.returnPromise">
              <span class="iconfont icon-a-ziyuan21"></span>
              <p>退换货承诺</p>
            </li>
          </div>
        </div>
      </div>
      <div class="mt20">
        <span class="mr100">询价数量&nbsp;:</span>
        <InputNumber
          v-model="enquirynum"
          controls-outside
          :min="1"
          :precision="0"
          @on-change="changexjNum"
        ></InputNumber>
      </div>
      <div class="flexjz mt20">
        <Button type="error" @click="enquiryqd" class="bt10 mr50">确定</Button>
        <Button type="error" @click="enquiryqx" class="bt10">取消</Button>
      </div>
    </Modal> -->
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
    <slider></slider>
  </div>
</template>

<script>
import headerTop from '@/views/base/common/header-top.vue'
import headerSearch from '@/views/base/common/header-search.vue'
import xiaopei from '@/views/xiaopei/index.vue'
import Footer from '@/views/base/common/footer.vue'
import footerP from '@/views/base/common/footer-p.vue'
import enquirytk from '@/views/base/common/enquirytk.vue'
import {
  getshopcar,
  getcollect,
  getpurchase,
  getattentionlist
} from '@/api/mineattention/attention'
import { getbuygoods } from '@/api/Partsdetails'
import { getenquiryqd } from '@/api/goodsList.js'
import slider from '@/views/base/common/slider.vue'
export default {
  name: 'attention',
  components: {
    headerTop,
    headerSearch,
    xiaopei,
    Footer,
    footerP,
    enquirytk,
    slider
  },
  data() {
    return {
      isCity: '',
      show: false, // 显示出过滤的东西
      value11: 1, // 购买数量
      enquirytk: false, // 立即询价的弹框
      enquirynum: 1, // 询价数量
      enquirydata: {}, // 询价数据
      sheetlist: [
        // {
        //   id: '',
        //   pictureUrl: '',
        //   typeName: '', // 原厂件
        //   carBrandName: '', // 奔驰
        //   stdNameJp: '', //水箱散热器
        //   oeCode: '', // A169500183
        //   genuineGuarantee: '', // 正品保证
        //   technicalSupport: '', //技术支持
        //   warrantyService: '', // 保修服务
        //   returnPromise: '', // 退换货承诺
        //   shopName: '', // 店铺
        //   stock: 0, // 库存
        //   unitId: '', // 单位
        //   provinceName: '', // 省份
        //   cityName: '', // 市区
        //   price: '', // 价格
        //   inquiry: 1, // 是否是询价
        //   type: 0, // 是否有活动
        //   activityTime: '', // 活动时间
        //   orderQuantity: 1, // 购买数量的最小值
        //   priceReduction: '' // 是否降价(降价多少)
        // }
      ], // 关注信息表
      attentionlist: [], // 我的关注数据
      checkedType: -1, // 颜色
      partType: '', // 传输的关注名称
      allattention: '', // 全部关注
      spinShow: false, // 加载
      // 分页
      pager: {
        current: 1,
        total: 0,
        size: 30
      }
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 数据渲染
    async getDataList() {
      this.spinShow = true
      const res = await getattentionlist({
        partType: this.partType ? this.partType : '',
        current: this.pager.current,
        size: this.pager.size
      })
      this.spinShow = false
      if (res.status) {
        this.$nextTick(() => {
          this.attentionlist = res.data.wssTreeNodeList
          console.log(this.attentionlist)
          this.sheetlist = res.data.ipage2.records
          this.allattention = res.data.count
          this.pager.total = res.data.ipage2.total
          // this.pager.current = res.data.ipage.current
          this.renovatenum()
        })
      }
    },
    // 购买数量的起订数
    renovatenum() {
      this.sheetlist.forEach((item) => {
        item.maxNum = item.orderQuantity ? item.orderQuantity : 1
      })
    },
    // 关注点击变化
    checkedEvent(id, index) {
      console.log(id, index)
      this.partType = id
      this.checkedType = index
      this.Pagechange()
    },
    // 全部关注
    allattentiondj() {
      this.partType = ''
      this.checkedType = -1
      this.Pagechange()
    },
    // 分页变化
    Pagechange() {
      this.pager.current = 1
      this.pager.size = 30
      this.getDataList()
    },
    // 分页选择
    changeSizegz(size) {
      console.log(size)
      this.pager.current = 1
      this.pager.size = size
      this.getDataList()
    },
    // 点击分页(1,2,3)
    changeCurrentgz(current) {
      this.pager.current = current
      this.getDataList()
    },
    // 入场动画之前
    beforeEnter(el) {
      el.style.opacity = 0
    },
    // 入场动画过程中
    enter(el, done) {
      let delay = el.dataset.index * 100
      setTimeout(() => {
        el.style.transition = 'opacity 0.4s '
        el.style.opacity = 1
        el.style.animation = 'one-in 0.4s infinite'
        el.style['animation-iteration-count'] = 1
        done()
      }, delay)
    },
    // 跳转详情
    skipxq(item) {
      console.log(item)
      if (item.saleStatus !== 2) {
        this.$router.push({
          path: '/Partsdetails',
          query: {
            partId: item.id
          }
        })
      }
    },
    // 跳转店铺
    skipdp(item) {
      console.log(item)
      if (item.saleStatus !== 2) {
        this.$router.push({
          path: '/homePage',
          query: {
            tenantId: item.tenantId,
            shopId: item.shopId,
            shopName: item.shopName
          }
        })
      }
    },
    // oe展开
    getRelevance(index, item) {
      console.log(item)
      this.$set(this.sheetlist[index], 'isShow', true)
    },
    // 关闭oe
    closeRelevance(index) {
      // console.log(index)
      this.$set(this.sheetlist[index], 'isShow', false)
    },
    // 购买数量变化
    async buygoods(item, index) {
      console.log(item.maxNum)
      item.stockNumber = 999999
      // this.$nextTick(() => {
      if (item.maxNum > item.stock) {
        item.stockNumber = item.maxNum - 1
        // item.isNumber = true
        // item.maxNum = item.stock
      } else {
        if (item.maxNum == item.stock) {
          item.stockNumber = item.maxNum
        }
        if (item.maxNum == null) {
          // item.maxNum = null
          this.$Message.error('请输入正确购买数量')
        } else {
          item.maxNum = Math.floor(item.maxNum)
        }
        this.$set(this.sheetlist[index], 'isNumber', false)
      }
      // })
    },
    // 失焦触发
    double(item, index) {
      if (item.maxNum > item.stock) {
        this.$set(this.sheetlist[index], 'isNumber', true)
      } else {
        this.$set(this.sheetlist[index], 'isNumber', false)
      }
    },
    // 数据失焦时触发
    async BlurNumber(item, index) {
      console.log(item, index)
      let reg = /^[1-9]\d*$/
      if (!reg.test(item.maxNum)) {
        this.$Message.error('请输入正确的购买数量！')
      } else {
        if (item.inquiry == 1) {
        } else {
          if (item.maxNum > item.stock) {
            this.$set(this.sheetlist[index], 'Add', true)
            this.$set(this.sheetlist[index], 'isNumber', true)
            this.$set(this.sheetlist[index], 'Sub', false)
          } else if (item.maxNum == item.stock) {
            this.$set(this.sheetlist[index], 'isNumber', false)
          }
          // if (item.maxNum > item.stock || item.maxNum == item.stock) {
          //   this.$set(this.sheetlist[index], 'Add', true)
          //   console.log('333333')
          //   // if (item.maxNum > item.stock) {
          //   this.$set(this.sheetlist[index], 'isNumber', true)
          //   // }
          //   // else if (item.maxNum == item.stock) {
          //   //   this.$set(this.dataList[index], 'isNumber', false)
          //   // }
          // }
          else {
            this.$set(this.sheetlist[index], 'Add', false)
            this.$set(this.sheetlist[index], 'isNumber', false)
            this.$set(this.sheetlist[index], 'Sub', false)
            if (item.maxNum == 1) {
              this.$set(this.sheetlist[index], 'Sub', true)
            }
          }
          console.log(item)
          const res = await getbuygoods({
            tenantId: item.tenantId,
            shopId: item.shopId,
            partId: item.id,
            partNum: item.maxNum,
            storeId: item.shipCityStore.storeId
          })
          if (res.status) {
            item.price = res.data.price
            // this.$set(this.dataList[index], 'isNumber', false)
          }
        }
        // }
      }
    },
    // 减法
    cliSub(item, index) {
      if (item.maxNum == 1) {
        // this.$set(this.dataList[index], 'Sub', true)
      } else {
        let oipt = document.getElementById(index)
        this.$delete(this.sheetlist[index], 'maxNum')
        this.$set(this.sheetlist[index], 'maxNum', oipt.value * 1 - 1)
        this.BlurNumber(item, index)
        // this.$set(this.dataList[index], 'Sub', false)
      }
    },
    // 加法
    cliAdd(item, index) {
      if (item.maxNum == item.stock) {
        this.$set(this.sheetlist[index], 'Add', true)
      } else {
        let oipt = document.getElementById(index)
        this.$delete(this.sheetlist[index], 'maxNum')
        this.$set(this.sheetlist[index], 'maxNum', oipt.value * 1 + 1)
        this.BlurNumber(item, index)
      }
    },
    // 购买数量触发
    // strike(item) {
    //   if (item.maxNum == null) {
    //     this.renovatenum()
    //     this.$nextTick(() => {
    //       item.maxNum = item.orderQuantity
    //     })
    //   }
    // },

    // 加入购物车
    async joinshopcar(item, index) {
      if (item.maxNum) {
        item.maxNum = item.maxNum
      } else {
        this.$Message.error('请输入正确购买数量!')
        return
      }
      if (item.maxNum < item.orderQuantity) {
        this.$Message.destroy()
        this.$Message.error('购买数量不能小于起订数量!')
        return
      }
      let data = {
        tenantId: item.tenantId,
        shopId: item.shopId,
        shopName: item.shopName,
        partId: item.id,
        partCode: item.oeCode,
        partNum: item.maxNum,
        partQualityType: item.qualityTypeId,
        carBrandName: item.carBrandName,
        partInnerId: item.partInnerId,
        price: item.price,
        direction: item.direction,
        stdNameJp: item.stdNameJp ? item.stdNameJp : '',
        storeId: item.shipCityStore.storeId
      }
      if (item.stock !== 0 && item.stock >= item.orderQuantity) {
        const res = await getshopcar(data)
        if (res.status) {
          this.$Message.destroy()
          this.$Message.success('加入购物车成功')
          this.$refs.store.getCount()
          this.getDataList()
        }
      } else {
        this.$Message.destroy()
        this.$Message.error('库存不足!')
      }
    },
    // 收藏
    async collect(item) {
      item.attention = !item.attention
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      const res = await getcollect({
        partId: item.id,
        attention: item.attention
      })
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        this.getDataList()
        return
      } else {
        item.attention = !item.attention
      }
    },
    // 立即购买
    async promptlybuy(item) {
      if (item.maxNum) {
        item.maxNum = item.maxNum
      } else {
        this.$Message.error('请输入正确购买数量!')
        return
      }
      if (item.maxNum < item.orderQuantity) {
        this.$Message.destroy()
        this.$Message.error('购买数量不能小于起订数量')
        return
      }
      if (item.stock !== 0 && item.stock >= item.orderQuantity) {
        const res = await getpurchase({
          partId: item.id, // 商品id
          tenantId: item.tenantId, // 店铺的租户id
          partNum: item.maxNum == null ? item.orderQuantity : item.maxNum, // 购买数量
          shopId: item.shopId, // 热销id
          storeId: item.shipCityStore.storeId
        })
        if (res.status) {
          this.$router.push({
            path: '/orderInformation',
            query: { pid: res.data.previewOrderId }
          })
        }
      } else {
        this.$Message.destroy()
        this.$Message.error('库存不足!')
      }
    },
    // 立即询价
    promptlyxj(item) {
      console.log(item)
      // this.enquirytk = true
      this.$refs.enquirytkl.enquirytkc()
      this.enquirydata = JSON.parse(JSON.stringify(item))
    },
    // 询价刷新
    enquirysx() {
      this.$refs.store.getenquirydata()
    },
    // // 立即询价数量
    // changexjNum(value) {
    //   console.log(value)
    // },
    // // 询价确定
    // async enquiryqd() {
    //   let data = {
    //     enquiryNum: this.enquirynum,
    //     offerTid: this.enquirydata.tenantId,
    //     offerTname: this.enquirydata.shopName,
    //     partId: this.enquirydata.partId
    //   }
    //   const res = await getenquiryqd(data)
    //   if (res.status) {
    //     this.enquirytk = false
    //     this.$Message.success('询价成功')
    //   }
    // },
    // // 询价取消
    // enquiryqx() {
    //   this.enquirytk = false
    // },
    // 搜同款
    same(row) {
      this.$router.push({
        path: '/partsSearch',
        query: { searchContent: row.oeCode }
      })
    },
    // 展示发货地
    getCity(index, item) {
      console.log(item)
      this.isCity = item.shipCityStore.name
      // this.isCity = item.oemCodes[0]
      console.log(this.isCity)
      console.log(this.sheetlist[index])
      this.$set(this.sheetlist[index], 'isShows', true)
    },
    checkCITY(i, item) {
      console.log(i, item)
      this.isCity = i.name
      item.shipCityStore = i
      item.stock = i.stock
    },
    // 关闭发货地
    closeCity(index) {
      console.log(index)
      this.$set(this.sheetlist[index], 'isShows', false)
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
.a {
  display: inline-block;
}
</style>
